import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ILinkApprovalResult, ILinkApprovalTokenState } from 'app/models/common/account-link-approval';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountLinkApprovalService {
  private readonly publicApi = environment.publicApi;

  constructor(private readonly http: HttpClient) {}

  validateToken(token: string): Observable<ILinkApprovalTokenState> {
    const params = new HttpParams().set('token', token || '');
    return this.http.get<ILinkApprovalTokenState>(this.publicApi + 'AccountLinkApproval/Validate', { params });
  }

  approveToken(token: string): Observable<ILinkApprovalResult> {
    return this.http.post<ILinkApprovalResult>(this.publicApi + 'AccountLinkApproval/Approve', { token });
  }

  denyToken(token: string): Observable<ILinkApprovalResult> {
    return this.http.post<ILinkApprovalResult>(this.publicApi + 'AccountLinkApproval/Deny', { token });
  }
}
